<template>
  <div>
    <div v-if="isLoading === true">
      <IconBell class="w-6 h-6 cursor-pointer">
      </IconBell>
    </div>
    <div v-else>
      <div class="flex items-end">
        <div class="mb-1.5 mr-3">
          <ClientNews :has-news="clientReleasesList.length > 0"></ClientNews>
        </div>
        <div class="mb-1.5 mr-3">
          <KlgNews :has-news="filterReleasesList.length > 0"></KlgNews>
        </div>
        <div @click="navbarStore.toggleNotificationsList()">
          <IconBell class="w-6 h-6 cursor-pointer">
          </IconBell>
        </div>
        <div v-if="navbarStore.activeNotifications > 0 "
             class="bg-primary rounded-full w-7 h-4 text-center text-xs text-white">
          {{ navbarStore.activeNotifications }}
        </div>
        <div v-if="maintenancesWithoutInteraction.length > 0"
             class="bg-red-600 rounded-full w-7 h-4 flex justify-center ml-1 items-center text-center text-xs text-white">
          {{ maintenancesWithoutInteraction.length }}
        </div>
        <div v-if="releasesWithoutInteraction.length > 0 "
             class="bg-orange rounded-full w-7 h-4 flex justify-center ml-1 items-center text-center text-xs text-white">
          {{ releasesWithoutInteraction.length }}
        </div>
        <div v-if="navbarStore.notificationsListOpen == true">
          <div class="bg-black bg-opacity-20 w-full h-full fixed left-0 right-0 top-0 bottom-0 z-[999]"></div>

          <div>
            <div
                class="fixed right-6 rounded-lg bg-white w-[500px] z-[9999999] top-[64px] h-custom-notif shadow-soft2xl overflow-auto">
              <div class="">
                <div class="flex justify-between sticky top-0 bg-white p-4 shadow-softxs">
                  <div class="flex justify-end gap-1 items-center">
                    <div class="flex items-center gap-1 px-3 py-1"
                         :class=" activeTab == 0 ? 'bg-primary rounded-full bg-opacity-10' :''">
                      <p @click="activeTab = 0" class="text-black text-sm font-semibold cursor-pointer">Notifications</p>
                      <div
                          class="bg-primary rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                        {{ navbarStore.activeNotifications }}
                      </div>
                    </div>
                    <div class="flex items-center gap-1 py-1 px-3"
                         :class=" activeTab == 1 ? 'bg-primary rounded-full bg-opacity-10 ' :''">
                      <p @click="activeTab = 1" class="text-black text-md font-semibold cursor-pointer">Maintenances</p>
                      <div
                          class="bg-red-600 rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                        {{ maintenancesWithoutInteraction.length }}
                      </div>
                    </div>
                    <div class="flex items-center gap-1 py-1 px-3"
                         :class=" activeTab == 2 ? 'bg-primary rounded-full bg-opacity-10 ' :''">
                      <p @click="activeTab = 2" class="text-black text-sm font-semibold cursor-pointer">Releases</p>
                      <div
                          class="bg-orange rounded-full w-7 h-5 flex justify-center items-center text-center text-xs text-white">
                        {{ releasesWithoutInteraction.length }}
                      </div>
                    </div>
                  </div>
                  <IconClose @click="navbarStore.closeNotificationsList()"
                             class="fill-primary cursor-pointer"></IconClose>
                </div>
                <div>
                <template v-if="activeTab === 0">
                  <div v-if="navbarStore.filteredSiteNotifications.length === 0" class="ml-4 mt-4 font-semibold">
                    No notifications available
                  </div>
                  <div v-else class="">
                    <template v-for="site_notification in navbarStore.filteredSiteNotifications">
                      <div v-if="userInteraction(site_notification.notificationInteractions)">
                        <div class="p-6 border-b border-slate-400 bg-[#Fff] w-full flex flex-col space-y-4 cursor-pointer"
                             @click="notificationSeen(site_notification.id,'site_notification'); toggleExpanded(site_notification.id,'admin_message')">
                          <div class="flex justify-end">
                              <span class="text-blue-700 font-bold">
                              {{ DateFilterHelper.FormatAsDateWithMonthString(site_notification.admin_from) }}
                              </span>
                          </div>
                          <div class="flex justify-between">
                            <strong>{{ site_notification.admin_name }}</strong>

                          </div>
                          <div class="font-medium cursor-pointer text-sm ck-content"
                               v-html="truncateText(site_notification.id, 'admin_message', site_notification.admin_message, 40)">
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                            class="p-6 border-b border-slate-400 bg-[#F3F8FF] w-full flex flex-col space-y-4 cursor-pointer"
                            @click="notificationSeen(site_notification.id,'site_notification'); toggleExpanded(site_notification.id,'admin_message')">
                          <div class="flex justify-end">
                              <span class="text-blue-700 font-bold justify-end">
                                {{ DateFilterHelper.FormatAsDateWithMonthString(site_notification.admin_from) }}
                              </span>
                          </div>
                          <div class="flex justify-start items-center gap-3">
                            <div class="w-2 h-2 bg-primary rounded-full">
                            </div>
                            <div>
                              <strong>{{ site_notification.admin_name }}</strong>

                            </div>
                          </div>
                          <div class="font-medium cursor-pointer text-sm ck-content ml-5"
                               v-html="truncateText(site_notification.id, 'admin_message', site_notification.admin_message, 40)">
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else-if="activeTab === 1">
                  <div v-if="maintenanceList.length === 0" class="ml-4 mt-4 font-semibold">
                    No maintenances available
                  </div>
                  <template v-for="maintenance in maintenanceList">
                    <div>
                      <div class="p-6 border-b border-slate-400 w-full flex flex-col space-y-4 cursor-pointer"
                           :class="userInteraction(maintenance.notificationInteractions) ? 'bg-[#Fff]' : 'bg-[#F3F8FF]'"
                           @click="notificationSeen(maintenance.id, 'maintenance')"
                      >
                        <div class="flex justify-end">
                              <span class="text-red-600 font-bold">
                              {{ DateFilterHelper.FormatAsDateWithMonthString(maintenance.from) }}
                              </span>
                        </div>
                        <div class="flex justify-start items-center gap-3">
                          <div class="w-2 h-2 bg-primary rounded-full">
                          </div>

                          <div class="font-semibold">
                            {{ maintenance.name }}
                          </div>
                        </div>
                        <div class="font-medium cursor-pointer text-sm ck-content ml-5"
                             v-html="maintenanceRenderedText(maintenance.id)">
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div v-if="releasesList.length === 0" class="ml-4 mt-4 font-semibold">
                    No release available
                  </div>
                  <template v-for="release in releasesList">
                    <div v-if="userInteraction(release.notificationInteractions)"
                         @click="notificationSeen(release.id, 'release')">
                      <div class="p-6 border-b border-slate-400 bg-[#Fff] w-full flex flex-col cursor-pointer">
                        <div class="flex justify-end"><p class="text-orange font-bold block float-right">
                          {{ DateFilterHelper.FormatAsDateWithMonthString(release.admin_release_date) }}
                        </p></div>
                        <div class="flex justify-between mb-3">
                          <strong>{{ release.admin_title }}</strong>
                        </div>
                        <div v-html="release.admin_short_description">
                        </div>
                      </div>
                    </div>
                    <div v-else
                         class="p-6 border-b border-slate-400 bg-[#F3F8FF] w-full flex flex-col  cursor-pointer"
                         @click="notificationSeen(release.id, 'release')">
                      <div class="flex justify-end"><p class="text-orange font-bold block float-right">
                        {{ DateFilterHelper.FormatAsDateWithMonthString(release.admin_release_date) }}
                      </p></div>

                      <div class="flex justify-start items-center gap-3 mb-3">
                        <div class="w-2 h-2 bg-primary rounded-full">
                        </div>
                        <div class="flex justify-between">
                          <strong>{{ release.admin_title }}</strong>
                        </div>
                      </div>
                      <div v-html="release.admin_short_description">
                      </div>
                    </div>
                  </template>
                </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SiteNotificationPopup v-if="navbarStore.notificationPopupOpen"></SiteNotificationPopup>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconClose from "@/components/svg_icons/IconClose.vue";
import IconBell from "@/components/svg_icons/IconBell.vue";
import {SiteNotification, type SiteNotificationData} from "@/types/site_admin/siteNotifications";
import {computed, ref, watch} from "vue";
import {useApiStore} from "@/stores/api";
import {useNavbarStore} from "@/stores/navbar";
import SiteNotificationPopup from "@/components/widgets/notifications/SiteNotificationPopup.vue";
import type {QueryFilter} from "@/types/object_classes/QueryFilter";
import {useAuthStore} from "@/stores/auth";
import {Maintenance, type MaintenanceData} from "@/types/site_admin/maintenances";
import {Release, type ReleaseData} from "@/types/site_admin/releases";
import Mustache from 'mustache';
import {DateFilterHelper} from "@/helpers/DateFilterHelper";
import {useRouter} from "vue-router";
import {NotificationInteraction} from "@/types/site_admin/notificationInteraction";
import Style from "@/views/Style.vue";
import type {JsonApiPagination} from "@/types/object_classes/JsonApiPagination.ts";
import ClientNews from "@/components/widgets/navbar/ClientNews.vue";
import KlgNews from "@/components/widgets/navbar/KlgNews.vue";

const router = useRouter();
const api = useApiStore();
const authStore = useAuthStore();
const navbarStore = useNavbarStore();
const isLoading = ref(false);
const activeTab = ref(0);
const expandedItems = ref({});
const maintenances = ref<Maintenance[]>([]);
const releasesList = ref<Release[]>([]);
const clientReleaseList = ref<Release[]>([]);
const current_timestamp = Date.now();

const maintenanceRenderedText = computed(() => (maintenance_id) => {
  const maintenanceData = maintenanceList.value.find(el => el.id === maintenance_id);

  const data = JSON.parse(JSON.stringify(maintenanceData.extra_data));
  data.from = DateFilterHelper.FormatAsDateWithDotsAndHours(data.from);
  data.until = DateFilterHelper.FormatAsDateWithDotsAndHours(data.until);

  return Mustache.render(maintenanceData.text, data);
});

const maintenanceList = computed(() => {
  return maintenances.value.filter(el => el.admin_enabled === true && el.until?.getTime() >= current_timestamp);
});

const filterReleasesList = computed(() => {
  return releasesList.value.filter(el => el.admin_release_enabled === true && el.admin_from?.getTime() <= current_timestamp && el.admin_until?.getTime() > current_timestamp);
});

const clientReleasesList = computed(() => {
  return clientReleaseList.value.filter(el => el.client_release_enabled === true && el.client_from?.getTime() <= current_timestamp && el.client_until?.getTime() > current_timestamp);
});

const maintenancesWithoutInteraction = computed(() => {
  let maintenancesWithout = [];
  maintenanceList.value.forEach(maintenance => {
    if (!maintenance.notificationInteractions.find(el => el.user_id == authStore.user.id)) {
      maintenancesWithout.push(maintenance);
    }
  })
  return maintenancesWithout;
})

const releasesWithoutInteraction = computed(() => {
  let releasesWithout = [];
  filterReleasesList.value.forEach(release => {
    if (!release.notificationInteractions.find(el => el.user_id == authStore.user.id)) {
      releasesWithout.push(release);
    }
  })
  return releasesWithout;
})

const loadFromServer = () => {
  isLoading.value = true;

  const notificationFilter: QueryFilter = {
    delimiter: null,
    field: "admin_enabled",
    values: [1]
  }
  const adminReleaseFilter: QueryFilter = {
    delimiter: null,
    field: "valid_entries",
    values: ['admin']
  }
  const clientReleaseFilter: QueryFilter = {
    delimiter: null,
    field: "valid_entries",
    values: ['client']
  }

  const notificationPagination : JsonApiPagination = {
    page_number: 1,
    page_size: 5
  }
  const adminReleasePagination: JsonApiPagination = {
    page_number: 1,
    page_size: 2
  }

  const notificationSortBy = ['-admin_from', '-id'];
  const maintenanceSortBy = ['-from', '-id'];
  const adminReleaseSortBy = ['-admin_release_date', '-id'];
  const clientReleaseSortBy = ['-client_release_date', '-id'];

  const getSiteNotifications = api.getItems<SiteNotification, SiteNotificationData>(
      'site-notifications',
      SiteNotification,
      ['notificationInteractions'],
      {'site-notifications':['admin_force_show','admin_message', 'admin_name', 'admin_enabled','admin_from','admin_until','notificationInteractions']},
      [notificationFilter],
      notificationPagination,
      notificationSortBy
  );
  const getMaintenances = api.getItems<Maintenance, MaintenanceData>(
      'maintenances',
      Maintenance,
      ['notificationInteractions'],
      undefined,
      undefined,
      undefined,
      maintenanceSortBy
  );
  const getAdminReleases = api.getItems<Release, ReleaseData>(
      'releases',
      Release,
      ['notificationInteractions'],
      {releases: ['admin_short_description', 'admin_title', 'admin_release_date', 'admin_from','admin_until', 'admin_release_enabled','notificationInteractions']},
      [adminReleaseFilter],
      adminReleasePagination,
      adminReleaseSortBy
  );
  const getClientReleases = api.getItems<Release, ReleaseData>(
      'releases',
      Release,
      undefined,
      {releases: ['client_release_enabled','client_from','client_until', 'client_release_date']},
      [clientReleaseFilter],
      undefined,
      clientReleaseSortBy
  );

  Promise.allSettled([getSiteNotifications, getMaintenances, getAdminReleases, getClientReleases])
      .then((result) => {
        if (result[0].status !== "fulfilled") {
          console.log("failed getting site notifications data", result);
          return;
        }
        if (result[1].status !== "fulfilled") {
          console.log("failed getting maintenances data", result);
          return;
        }
        if (result[2].status !== "fulfilled") {
          console.log("failed getting admin releases data", result);
          return;
        }
        if (result[3].status !== "fulfilled") {
          console.log("failed getting client releases data", result);
          return;
        }

        navbarStore.siteNotificationsList = result[0].value;
        navbarStore.siteNotificationsList.forEach(sn => {
          if (sn.admin_from?.getTime() <= current_timestamp && sn.admin_until?.getTime() >= current_timestamp) {
            expandedItems.value[`${sn.id}_admin_message`] = true;
          }
        })
        navbarStore.openPopupNextPopupNotification();

        maintenances.value = result[1].value;
        releasesList.value = result[2].value;
        clientReleaseList.value = result[3].value;
      })
      .finally(() => {
        isLoading.value = false;
      })
}
loadFromServer();

const userInteraction = computed(() => (notificationInteractions: NotificationInteraction[]) => {
  return notificationInteractions.filter(el => el.user_id === authStore.user.id).length;
})

const truncateText = computed(() => (id: number, name: string, text: string, maxLength: number) => {
  const key = `${id}_${name}`;

  if (expandedItems.value[key] === undefined || expandedItems.value[key] === false) {
    if (text?.length > maxLength) {
      const html_doc = new DOMParser().parseFromString(text, 'text/html');
      return html_doc.body.textContent.slice(0, maxLength) + '...'
    }
  }

  return text;
});

const goToReleases = (release_id: number) => {
  router.push({name: 'news', hash: `#release_${release_id}`});
  navbarStore.closeNotificationsList();
}

const notificationSeen = (notification_id: number, notification_type: string) => {
  switch (notification_type) {
    case "site_notification":
      let notif = navbarStore.filteredSiteNotifications.find(el => el.id === notification_id);
      if (notif.notificationInteractions.find(el => el.user_id === authStore.user.id)) {
        return;
      }
      break;
    case "release":
      let release = releasesList.value.find(el => el.id === notification_id);
      if (release.notificationInteractions.find(el => el.user_id === authStore.user.id)) {
        // console.log('aaaa')
        goToReleases(notification_id);
        return;
      }
      break;
    case "maintenance":
      let maintenance = maintenanceList.value.find(el => el.id === notification_id);
      if (maintenance.notificationInteractions.find(el => el.user_id === authStore.user.id)) {
        return;
      }
      break;
  }

  const payload = {
    notification_id: notification_id,
    notification_type: notification_type,
  }

  api.createItem('notification-interactions', payload, NotificationInteraction)
      .then((result) => {
        switch (notification_type) {
          case "site_notification":
            let notif = navbarStore.filteredSiteNotifications.find(el => el.id === notification_id);
            notif.notificationInteractions.push(result);
            break;
          case "release":
            let release = releasesList.value.find(el => el.id === notification_id);
            release.notificationInteractions.push(result);
            break;
          case "maintenance":
            let maintenance = maintenanceList.value.find(el => el.id === notification_id);
            maintenance.notificationInteractions.push(result);
            break;
        }
      })
      .catch((err) => {
        console.log(err, 'error')
      })
      .finally(() => {
        if (notification_type === 'release') {
          goToReleases(notification_id);
        }
      })
}

const toggleExpanded = computed(() => (id: number, name: string) => {
  const key = `${id}_${name}`;

  if (expandedItems.value[key] === undefined) {
    expandedItems.value[key] = true;
  } else {
    expandedItems.value[key] = !expandedItems.value[key];
  }

});
</script>

<style scoped>
.ck-content ::v-deep(a) {
  text-decoration: underline;
  color: #1f69c0;
}
.ck-content ::v-deep(div) {
 width:auto !important;
}
</style>